import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { request } from "@/lib/request";
import { Loader2Icon, MailWarningIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export const DeleteAccount = () => {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);

  const handleRequest = async () => {
    setPending(true);
    try {
      await request.delete(`/auth/user/request-delete`).catch(err => {
        throw new Error(err.response?.data.message);
      });

      toast.success("Request submitted", {
        description: "Please check your email for further instructions.",
      });
      setOpen(false);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setPending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive">
          <MailWarningIcon /> Submit Request
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Account</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Are you sure you want to delete your account? This action is
          irreversible and all your data will be lost.
        </DialogDescription>
        <DialogFooter>
          <Button size="sm" variant="default">
            Cancel
          </Button>
          <Button
            size="sm"
            variant="destructive"
            onClick={handleRequest}
            disabled={pending}
          >
            {pending ? (
              <>
                <Loader2Icon className="animate-spin" /> Sending Request
              </>
            ) : (
              <>
                <MailWarningIcon /> Submit Request
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
